import { GetSurgialOrderCounter } from 'domain/usecases/surgical-order/get-surgical-order-counter'
import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'

export class RemoteGetSurgicalOrderCounter implements GetSurgialOrderCounter {
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  count(
    params: GetSurgialOrderCounter.Params
  ): Promise<GetSurgialOrderCounter.Model> {
    return this.surgicalOrderRepository.getSurgicalOrderCounter(params)
  }
}
